<div class="business-navbar__container"
    [class.business-navbar__container--opened]="opened$ | async" (click)="toggle()"
    [style.padding-left.px]="indentation * 24">
    <i class="material-icons business-nav__container__right-arrow"
        [class.business-navbar__container__right-arrow--opened]="opened$ | async">arrow_right</i>
    <atlas-icon [matIcon]="icon" [logoUrl]="logoUrl" [productName]="label" *ngIf="showIcon">
    </atlas-icon>
    <div class="business-navbar__item-wrapper">
        <span class="business-navbar__item">
            <span class="business-navbar__item__text">{{ text$ | async }}</span>
        </span>
    </div>
    <atlas-chip *ngIf="!!chipContent" [text]="chipContent | translate:'Pro'" [isNavChip]="true"></atlas-chip>
</div>
<div class="business-navbar__container-items-wrapper">
    <div #container class="business-navbar__container-items"
        [class.business-nav__container--opened]="opened$ | async">
        <ng-content></ng-content>
    </div>
</div>
